import { c as _c } from "react/compiler-runtime";
import { IcoSparkles16 } from '@onefootprint/icons';
import type { Actor, AuditEvent } from '@onefootprint/request-types/dashboard';
import { Tag } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import BaseHoverCard from '../base-hover-card';
import InsightEventDisplay from './insight-event-display';
type PrincipalActorProps = {
  principal: Actor;
  insightEvent: AuditEvent['insightEvent'];
};
const PrincipalActor = t0 => {
  const $ = _c(15);
  const {
    principal,
    insightEvent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "principalActor"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  const firmEmployeeHasDetails = principal.kind === "firm_employee" && (principal.firstName || principal.lastName || principal.email);
  let t2;
  if ($[1] !== t) {
    t2 = principal_0 => {
      if (principal_0.kind === "footprint") {
        return t(_temp);
      }
      if (principal_0.kind === "firm_employee") {
        const name = [principal_0.firstName, principal_0.lastName].filter(Boolean).join(" ").trim();
        if (name && principal_0.email) {
          return `${name} (${principal_0.email})`;
        }
        if (name) {
          return name;
        }
        if (principal_0.email) {
          return principal_0.email;
        }
        return t(_temp2);
      }
      if (principal_0.kind === "organization") {
        const name_0 = [principal_0.firstName, principal_0.lastName].filter(Boolean).join(" ").trim();
        return `${name_0 || t(_temp3)} (${principal_0.email})`;
      }
      if (principal_0.kind === "api_key") {
        return `${t(_temp4)} (${principal_0.name})`;
      }
      if (principal_0.kind === "user") {
        return t(_temp5);
      }
      return "";
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getTextTrigger = t2;
  let t3;
  if ($[3] !== getTextTrigger || $[4] !== insightEvent || $[5] !== principal || $[6] !== t) {
    t3 = insightEvent ? <BaseHoverCard textTrigger={getTextTrigger(principal)} titleText={t(_temp6)} titleIcon={IcoSparkles16}><InsightEventDisplay insightEvent={insightEvent} /></BaseHoverCard> : <p className="underline text-label-2">{getTextTrigger(principal)}</p>;
    $[3] = getTextTrigger;
    $[4] = insightEvent;
    $[5] = principal;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const trigger = t3;
  if (firmEmployeeHasDetails) {
    let t4;
    if ($[8] !== t) {
      t4 = t(_temp7);
      $[8] = t;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t4) {
      t5 = <Tag>{t4}</Tag>;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t5 || $[13] !== trigger) {
      t6 = <div className="flex items-center gap-2">{trigger}{t5}</div>;
      $[12] = t5;
      $[13] = trigger;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    return t6;
  }
  return trigger;
};
export default PrincipalActor;
function _temp($) {
  return $.footprint;
}
function _temp2($_0) {
  return $_0.firmEmployee;
}
function _temp3($_1) {
  return $_1.employees;
}
function _temp4($_2) {
  return $_2.apiKey;
}
function _temp5($_3) {
  return $_3.aUser;
}
function _temp6($_4) {
  return $_4.insightEvent.title;
}
function _temp7($_5) {
  return $_5.footprint;
}